import React from "react";
import PropTypes from "prop-types";

export const ManualForm = ({
  onSubmit,
  handleSubmit,
  errors,
  register,
  vehicleLookup,
  handleMakeChange,
  handleModelChange,
  handleFuelTypeChange,
  handleYearOfRegistrationChange,
  colours
}) => {
  return (
    <form id="manualForm" onSubmit={handleSubmit(onSubmit)}>
      <p className="ch-fs--4 ch-mt--6">Or enter your details manually...</p>
      <div
        className={`ch-form__group ch-mb--0 
          ${errors.make ? "ch-form__group--error" : ""}`}
      >
        <label
          htmlFor="make"
          className="ch-form__control-label ch-width--12 ch-mb--3"
        >
          Make
          <span className="ch-form__control-validation">
            {errors.make?.message}
          </span>
          <select
            name="make"
            id="make"
            className="ch-form__control ch-color--grey-6"
            {...register("make")}
            onChange={(e) => handleMakeChange(e.target.value)}
            disabled={!vehicleLookup.manufacturers}
          >
            <option value="">Please select</option>
            {vehicleLookup.manufacturers?.map((make, i) => (
              <option value={make} key={i}>
                {make}
              </option>
            ))}
          </select>
        </label>
      </div>
      <div
        className={`ch-form__group ch-mb--0 
          ${errors.model ? "ch-form__group--error" : ""}`}
      >
        <label
          htmlFor="model"
          className="ch-form__control-label ch-width--12 ch-mb--3"
        >
          Model
          <span className="ch-form__control-validation">
            {errors.model?.message}
          </span>
          <select
            name="model"
            id="model"
            className="ch-form__control ch-color--grey-6"
            {...register("model")}
            onChange={(e) => handleModelChange(e.target.value)}
            disabled={!vehicleLookup.models}
          >
            <option value="">Please select</option>
            {vehicleLookup.models?.map((model, i) => (
              <option value={model} key={i}>
                {model}
              </option>
            ))}
          </select>
        </label>
      </div>
      <div
        className={`ch-form__group ch-mb--0 
          ${errors.fuelType ? "ch-form__group--error" : ""}`}
      >
        <label
          htmlFor="fuelType"
          className="ch-form__control-label ch-width--12 ch-mb--3"
        >
          Fuel type
          <span className="ch-form__control-validation">
            {errors.fuelType?.message}
          </span>
          <select
            name="fuelType"
            id="fuelType"
            className="ch-form__control ch-color--grey-6"
            {...register("fuelType")}
            onChange={(e) => handleFuelTypeChange(e.target.value)}
            disabled={!vehicleLookup.fuelTypes}
          >
            <option value="">Please select</option>
            {vehicleLookup?.fuelTypes?.map(({ id, fuelType }) => (
              <option value={id} key={id}>
                {fuelType}
              </option>
            ))}
          </select>
        </label>
      </div>
      <div
        className={`ch-form__group ch-mb--0
          ${errors.yearOfRegistration ? "ch-form__group--error" : ""}`}
      >
        <label
          htmlFor="yearOfRegistration"
          className="ch-form__control-label ch-width--12 ch-mb--3"
        >
          Year of registration
          <span className="ch-form__control-hint">
            The year followed by plate number
          </span>
          <span className="ch-form__control-validation">
            {errors.yearOfRegistration?.message}
          </span>
          <select
            name="yearOfRegistration"
            id="yearOfRegistration"
            className="ch-form__control ch-color--grey-6"
            {...register("yearOfRegistration")}
            onChange={(e) => handleYearOfRegistrationChange(e.target.value)}
            disabled={!vehicleLookup.productionYears}
            data-testid="yearOfRegistration"
          >
            <option value="">Please select</option>
            {vehicleLookup.productionYears
              ?.slice()
              .sort(
                (a, b) => b.dateOfRegistrationYear - a.dateOfRegistrationYear
              )
              .map((productionYear) => (
                <option
                  key={`${productionYear.dateOfRegistrationYear}-${productionYear.plate}`}
                  value={`${productionYear.dateOfRegistrationYear} ${productionYear.plate}`}
                >
                  {productionYear.dateOfRegistrationYear} /{" "}
                  {productionYear.plate}
                </option>
              ))}
          </select>
        </label>
      </div>
      <div
        className={`ch-form__group ch-mb--0
          ${errors.colour ? "ch-form__group--error" : ""}`}
      >
        <label
          htmlFor="colour"
          className="ch-form__control-label ch-width--12 ch-mb--3"
        >
          Colour
          <span className="ch-form__control-validation">
            {errors.colour?.message}
          </span>
          <select
            name="colour"
            id="colour"
            className="ch-form__control ch-color--grey-6"
            {...register("colour")}
          >
            <option value="">Please select</option>
            {colours.map((colour) => (
              <option value={colour} key={colour}>
                {colour[0].toUpperCase() + colour.slice(1)}
              </option>
            ))}
          </select>
        </label>
      </div>
      <div
        className={`ch-form__group ch-mb--0
          ${errors.metallicPaint ? "ch-form__group--error" : ""}`}
      >
        <label
          htmlFor="metallicPaint"
          className="ch-form__control-label ch-width--12 ch-mb--3"
        >
          Metallic paint
          <span className="ch-form__control-validation">
            {errors.metallicPaint?.message}
          </span>
          <select
            name="metallicPaint"
            id="metallicPaint"
            className="ch-form__control ch-color--grey-6"
            {...register("metallicPaint")}
          >
            <option value="">Please select</option>
            <option value="true">Yes</option>
            <option value="false">No</option>
          </select>
        </label>
      </div>
      <div
        className={`ch-form__group ch-mb--0
          ${errors.chooseYourCar ? "ch-form__group--error" : ""}`}
      >
        <label
          htmlFor="chooseYourCar"
          className="ch-form__control-label ch-width--12 ch-mb--3"
        >
          Choose your car
          <span className="ch-form__control-validation">
            {errors.chooseYourCar?.message}
          </span>
          <select
            name="chooseYourCar"
            id="chooseYourCar"
            className="ch-form__control ch-color--grey-6"
            {...register("chooseYourCar")}
            disabled={!vehicleLookup.derivatives}
          >
            <option value="">Please select</option>
            {vehicleLookup?.derivatives?.map(
              ({ vehicleId, derivativeDescription }) => (
                <option value={vehicleId} key={vehicleId}>
                  {derivativeDescription}
                </option>
              )
            )}
          </select>
        </label>
      </div>
      <div
        className={`ch-form__group ch-mb--0
          ${errors.previousOwners ? "ch-form__group--error" : ""}`}
      >
        <label
          htmlFor="previousOwners"
          className="ch-form__control-label ch-width--12 ch-mb--3"
        >
          Previous owners
          <span className="ch-form__control-hint">
            You'll find this on your V5 document
          </span>
          <span className="ch-form__control-validation">
            {errors.previousOwners?.message}
          </span>
          <select
            name="previousOwners"
            id="previousOwners"
            className="ch-form__control ch-color--grey-6"
            {...register("previousOwners")}
            data-testid="previousOwners"
          >
            <option value="">Please select</option>
            {[...Array(10).keys()].map((index) => (
              <option key={index} value={index}>
                {index}
              </option>
            ))}
          </select>
        </label>
      </div>
      <input
        className="ch-btn ch-btn--primary ch-width--12 ch-mb--4 ch-mt--2"
        type="submit"
        value="Value my vehicle"
      />
    </form>
  );
};

ManualForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  errors: PropTypes.shape({
    make: PropTypes.shape({
      message: PropTypes.string
    }),
    model: PropTypes.shape({
      message: PropTypes.string
    }),
    fuelType: PropTypes.shape({
      message: PropTypes.string
    }),
    yearOfRegistration: PropTypes.shape({
      message: PropTypes.string
    }),
    colour: PropTypes.shape({
      message: PropTypes.string
    }),
    metallicPaint: PropTypes.shape({
      message: PropTypes.string
    }),
    chooseYourCar: PropTypes.shape({
      message: PropTypes.string
    }),
    previousOwners: PropTypes.shape({
      message: PropTypes.string
    })
  }).isRequired,

  register: PropTypes.func.isRequired
};
